// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Change colors in this file to style to your needs on a global level. 
Certain colors are used for different and multiply types of elements. 
For greater control over colors visit each components .scss file. */
.contact-div-main {
  display: flex;
}

.dark-mode a {
  color: #ffffff;
}

.contact-div-main > * {
  flex: 1 1;
}

.contact-title {
  font-size: 65px;
  font-weight: 400;
}

.contact-detail,
.contact-detail-email {
  margin-top: 20px;
  font-size: 40px;
  font-weight: 400;
  color: #868e96;
  text-decoration: none;
}

.contact-detail:hover,
.contact-detail-email:hover {
  color: #000000;
  text-shadow: 2px 1px 2px #b5b5b5;
  transition: all 0.3s;
}

.contact-subtitle {
  text-transform: uppercase;
}

.contact-text-div {
  margin-top: 1.5rem;
}

.contact-margin-top {
  margin-top: 4rem;
}

.contact-image-div > img {
  max-width: 100%;
  height: auto;
  margin-left: 1.5rem;
  margin-top: -4rem;
}

/* Media Query */
@media (max-width: 1380px), (max-width: 768px) {
  .contact-title {
    font-size: 56px;
    font-weight: 400;
    text-align: center;
  }
  .contact-title {
    font-size: 40px;
    text-align: center;
  }
  .contact-subtitle {
    font-size: 16px;
    line-height: normal;
    text-align: center;
  }
  .contact-text-div {
    text-align: center;
    margin-top: 1.5rem;
  }
  .contact-detail,
  .contact-detail-email {
    font-size: 20px;
  }
  .contact-image-div {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/_globalColor.scss","webpack://./src/containers/contact/Contact.scss"],"names":[],"mappings":"AAAA;;mEAAA;ACEA;EACE,aAAA;AAEF;;AACA;EACE,cDWc;ACThB;;AACA;EACE,SAAA;AAEF;;AACA;EACE,eAAA;EACA,gBAAA;AAEF;;AACA;;EAEE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cDZS;ECaT,qBAAA;AAEF;;AACA;;EAEE,cDnBU;ECoBV,gCAAA;EACA,oBAAA;AAEF;;AACA;EACE,yBAAA;AAEF;;AACA;EACE,kBAAA;AAEF;;AACA;EACE,gBAAA;AAEF;;AACA;EACE,eAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;AAEF;;AACA,gBAAA;AACA;EACE;IACE,eAAA;IACA,gBAAA;IACA,kBAAA;EAEF;EACA;IACE,eAAA;IACA,kBAAA;EACF;EAEA;IACE,eAAA;IACA,mBAAA;IACA,kBAAA;EAAF;EAGA;IACE,kBAAA;IACA,kBAAA;EADF;EAIA;;IAEE,eAAA;EAFF;EAKA;IACE,aAAA;EAHF;AACF","sourcesContent":["/* Change colors in this file to style to your needs on a global level. \nCertain colors are used for different and multiply types of elements. \nFor greater control over colors visit each components .scss file. */\n\n// button colors\n$buttonColor: #55198b;\n$buttonHover: #8c43ce;\n$topButtonHover: #000;\n\n// text colors light theme\n$titleColor: #000000;\n$textColor: #000000;\n$subTitle: #868e96;\n$cardSubtitle: #666666;\n$talkCardSubTitle: #7f8287;\n$blogCardTitleColor: #262626;\n\n// text color dark theme\n$textColorDark: #ffffff;\n\n// toggle switch colors\n$toggleCheck: #2196f3;\n$toggleSwitchSliderBG: #ccc;\n\n// githubRepo specific colors\n$githubRepoCardLanguageColorBG: #0000ff;\n$githubRepoCardColor: rgb(88, 96, 105);\n$githubRepoCardRepoCardStatsColor: rgb(106, 115, 125);\n$githubRepoCardRepoNameColor: rgb(36, 41, 46);\n$githubProfileCardLocationTS: #ffebcd;\n$githubProfileCardBorder: #6c63ff;\n\n// light background colors\n$lightBackground1: #fff;\n$lightBackground2: rgb(255, 255, 255);\n$lightBackground3: #f5f2f4;\n$blogCardContainerColor: #586069;\n// dark background colors\n$darkBackground: #171c28;\n\n// light theme box shadows\n$lightBoxShadowDark: rgba(0, 0, 0, 0.2);\n$lightBoxShadow: rgba(0, 0, 0, 0.1);\n$lightBoxShadowDarker: rgba(0, 0, 0, 0.3);\n\n// dark theme box shadows\n$darkBoxShadow: #d9dbdf;\n$darkBoxShadow2: #ffffff;\n\n// linear gradients\n$experienceCardBlurredDivLG: linear-gradient(\n  rgba(0, 0, 0, 0.4),\n  rgba(0, 0, 0, 0.2)\n);\n$experienceCardBannerLG: linear-gradient(\n  rgba(0, 0, 0, 0.7),\n  rgba(0, 0, 0, 0.5)\n);\n\n// borders\n$progressBarBackground: rgb(243, 239, 239);\n$lightBorder1: rgba(211, 211, 211, 0.397);\n$educationCardBorder: #a9a7f9;\n\n// hovers\n$achievementCertificateCardHoverDark: rgba(255, 255, 255, 0.2);\n$blogCardHoverSmallColor: rgba(255, 255, 255, 0.8);\n$headerHoverBG: #f4f4f4;\n$contactDetailHoverTS: #b5b5b5;\n\n// misc backgrounds\n$progressBarSpanBG: #aaa5ff;\n$iconBackground: #333;\n$appHeaderBG: #282c34;\n\n// misc colors\n$skillsColor: #645beb;\n$appLink: #09d3ac;\n\n// social media icons\n$faceBook: #3b5998;\n$linkedin: #0e76a8;\n$github: #333;\n$gitlab: #fca326;\n$google: #ea4335;\n$twitter: #1da1f2;\n$medium: #000;\n$stackoverflow: #f48024;\n$instagram: #c13584;\n$kaggle: #20beff;\n","@import \"../../_globalColor\";\n\n.contact-div-main {\n  display: flex;\n}\n\n.dark-mode a {\n  color: $textColorDark;\n}\n\n.contact-div-main > * {\n  flex: 1;\n}\n\n.contact-title {\n  font-size: 65px;\n  font-weight: 400;\n}\n\n.contact-detail,\n.contact-detail-email {\n  margin-top: 20px;\n  font-size: 40px;\n  font-weight: 400;\n  color: $subTitle;\n  text-decoration: none;\n}\n\n.contact-detail:hover,\n.contact-detail-email:hover {\n  color: $textColor;\n  text-shadow: 2px 1px 2px $contactDetailHoverTS;\n  transition: all 0.3s;\n}\n\n.contact-subtitle {\n  text-transform: uppercase;\n}\n\n.contact-text-div {\n  margin-top: 1.5rem;\n}\n\n.contact-margin-top {\n  margin-top: 4rem;\n}\n\n.contact-image-div > img {\n  max-width: 100%;\n  height: auto;\n  margin-left: 1.5rem;\n  margin-top: -4rem;\n}\n\n/* Media Query */\n@media (max-width: 1380px), (max-width: 768px) {\n  .contact-title {\n    font-size: 56px;\n    font-weight: 400;\n    text-align: center;\n  }\n\n  .contact-title {\n    font-size: 40px;\n    text-align: center;\n  }\n\n  .contact-subtitle {\n    font-size: 16px;\n    line-height: normal;\n    text-align: center;\n  }\n\n  .contact-text-div {\n    text-align: center;\n    margin-top: 1.5rem;\n  }\n\n  .contact-detail,\n  .contact-detail-email {\n    font-size: 20px;\n  }\n\n  .contact-image-div {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
